import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { OrganizationDetails } from 'features/organizations/organizations.types';

export type UseOrganizationDetails = Omit<
  UseQueryResult<OrganizationDetails, Error>,
  'data'
> & {
  details?: OrganizationDetails;
};

const fetchOrganizationDetails = async (): Promise<OrganizationDetails> => {
  const result = await API.get<OrganizationDetails>('organization/details/');
  return result.data;
};

export const useOrganizationDetails = (): UseOrganizationDetails => {
  const { data, ...results } = useQuery<OrganizationDetails>({
    queryKey: ['organizationDetails'],
    queryFn: () => fetchOrganizationDetails(),
    staleTime: 1000 * 60, // 1 minute
  });

  return {
    ...results,
    details: data,
  };
};
